import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/customer-details/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.CustomerManagementScreen] && context.userPermissions.isAvalorInternalRole;
    context.validatePermissions({ isAllowed, preload });
  },
});
